// Desc: Preloader component to show a spinner when the app is loading.
import { PreLoader } from '@see-ui/core';
import React from 'react';
import { useSpinner } from '../../context/SpinnerContext';

const Spinner: React.FC = () => {
  const { isLoading } = useSpinner();

  if (!isLoading) return null;

  return (
    <div className="overlay">
      <PreLoader></PreLoader>
    </div>
  );
};

export default Spinner;
